import { RefObject, useEffect } from 'react';

import { Maybe, Optional } from '@vimeo/core/types/generic';

export function useQuestionsListScrollOnPinnedQuestionChange(
  listRef: RefObject<HTMLDivElement>,
  pinnedQuestionId: Maybe<string>,
  canScroll: boolean,
): void {
  useEffect(() => {
    if (!canScroll || !pinnedQuestionId) {
      return;
    }

    const list: Optional<HTMLDivElement> = listRef.current
      ?.parentElement as Optional<HTMLDivElement>;

    if (!list) {
      return;
    }

    if (list.scrollTop) {
      list.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [canScroll, pinnedQuestionId, listRef]);
}
